module.exports = __webpack_public_path__ + "89bcb45450678c6d3860aca6248f3759.png";